import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { LotteryDetailPage } from './lottery-detail';
import { BaselineSharedModule,BaselineLotteryModule } from 'baseline-lib';
import { SharedModule } from '../../shared/shared.module';
import { ProfileModule } from '../../profile/profile.module';


@NgModule({
  declarations: [
    LotteryDetailPage,
  ],
  imports: [
    BaselineSharedModule,
    BaselineLotteryModule,
    SharedModule,
    ProfileModule,
    IonicPageModule.forChild(LotteryDetailPage),
  ],
  exports: [
    LotteryDetailPage
  ]
})
export class LotteryDetailPageModule {}



// WEBPACK FOOTER //
// ./src/app/lottery/lottery-detail/lottery-detail.module.ts